document.addEventListener('DOMContentLoaded', function () {
  const products_on_page = document.getElementById('product-grid');
  const nextUrlElement = document.getElementById('paginateNext');
  
  if (!nextUrlElement) {
    console.error('Initial pagination link not found.');
    return;
  }
  
  let next_url = nextUrlElement.dataset.nextUrl;
  const load_more_btn = document.getElementsByClassName('load-more_btn')[0];
  const load_more_spinner = document.getElementsByClassName('load-more_spinner')[0];

  async function getNextPage() {
    try {
      console.log('Fetching next page from URL:', next_url); // Log fetch URL
      let res = await fetch(next_url);
      return await res.text();
    } catch (error) {
      console.error('Error fetching next page:', error);
    }
  }

  async function loadMoreProducts() {
    if (!next_url) {
      console.error('No next page URL available.');
      return;
    }

    // Show spinner and hide the button
    load_more_btn.style.display = 'none';
    load_more_spinner.style.display = 'block';

    // Fetch the next page
    let nextPageContent = await getNextPage();
    if (!nextPageContent) {
      console.error('Failed to fetch the next page.');
      load_more_spinner.style.display = 'none';
      return;
    }

    // Parse the fetched HTML
    const parser = new DOMParser();
    const nextPageDoc = parser.parseFromString(nextPageContent, 'text/html');

    // Hide spinner
    load_more_spinner.style.display = 'none';

    // Extract new products
    const productgrid = nextPageDoc.getElementById('product-grid');
    if (!productgrid) {
      console.error('Product grid not found in the fetched page.');
      return;
    }
    const new_products = productgrid.querySelectorAll('.grid__item');
    console.log('New products found:', new_products.length);

    // Update the next URL from the fetched page
    const newPaginateNext = nextPageDoc.getElementById('paginateNext');
    next_url = newPaginateNext ? newPaginateNext.dataset.nextUrl : null;

    // Append new products to the existing product grid
    new_products.forEach((product) => products_on_page.appendChild(product));
    console.log('Total products on the page after append:', products_on_page.children.length);

    // Show the Load More button again if there's another page
    if (next_url) {
      load_more_btn.style.display = 'inline-flex';
    } else {
      console.log('No more pages to load.');
    }
  }

  load_more_btn.addEventListener('click', loadMoreProducts);
});
